<template>
  <v-list>
    <IdNameForm :userData="userData" />

    <PasswordForm
      v-if="userData.signupPath !== 'kakao' && !isAuthorized"
      :userData="userData"
    />

    <EmailForm ref="refEmailForm" :userData="userData" />

    <AgeForm :userData="userData" />
  </v-list>
</template>
<script>
import { mapGetters } from "vuex";
import IdNameForm from "./comp/IdNameForm.vue";
import EmailForm from "./comp/EmailForm.vue";
import PasswordForm from "./comp/PasswordForm.vue";
import AgeForm from "./comp/AgeForm.vue";

export default {
  components: { IdNameForm, EmailForm, PasswordForm, AgeForm },
  props: {
    userData: {
      type: Object,
    },
  },
  computed: {
    ...mapGetters(["isAuthorized"]),
  },
  methods: {},
};
</script>
<style lang="scss">
div.v-list:not(.v-select-list) {
  background: transparent !important;
  .v-list-item {
    padding: 0;
    .v-list-item__content {
      padding: 0;
      column-gap: 5px;
    }
    .v-list-item__title {
      font-size: 14px;
      font-weight: bold;
      padding: 0 15px 5px;
      color: $primary-color;
      .asterisk {
        color: $text-red;
      }
    }
    &.email {
      .inner-content {
        display: flex;
        span {
          padding: 15px 6px;
          font-weight: 700;
        }
      }
    }
    .v-input {
      .v-input__slot {
        .v-btn {
          font-weight: 700;
          background-color: $mid-green;
          color: #ffffff;
          font-size: 12px;
          height: 28px;
          margin-right: -10px;
        }
      }
    }
    .v-input {
      & ~ .input-guide {
        display: block;
        font-size: 12px;
        padding: 0 10px 20px;
        margin-top: -5px;
      }
      &.error--text {
        & ~ .input-guide {
          display: none;
        }
      }
    }
  }
}
</style>